import { Link, useParams } from "react-router-dom";
import { TactikSiteTopBar } from "../app/TactikSiteTopBar";
import {
  STANDALONE_LEGAL_DOCS,
  STANDALONE_LEGAL_TITLES,
  isStandaloneLegalSlug,
} from "./standaloneLegalContent";
import "./StandaloneLegalDocPage.css";

/** Tactik 独立站法规页 */
export default function StandaloneLegalDocPage() {
  const { slug = "" } = useParams<{ slug: string }>();
  const known = isStandaloneLegalSlug(slug);
  const title = known ? STANDALONE_LEGAL_TITLES[slug] : "文档";
  const doc = known ? STANDALONE_LEGAL_DOCS[slug] : null;

  return (
    <div className="standalone-legal-layout">
      <TactikSiteTopBar />
      <div className="standalone-legal-page">
        <p className="standalone-legal-back">
          <Link to="/">返回首页</Link>
        </p>
        <h1 className="standalone-legal-h1">{title}</h1>
        {doc ? (
          <article className="standalone-legal-article">
            <p className="standalone-legal-p">更新日期：{doc.updatedAt}</p>
            {doc.preamble?.map((paragraph) => (
              <p key={paragraph} className="standalone-legal-p">
                {paragraph}
              </p>
            ))}
            {doc.sections.map((section) => (
              <section key={section.heading} className="standalone-legal-section">
                <h2 className="standalone-legal-h2">{section.heading}</h2>
                {section.paragraphs.map((paragraph) => (
                  <p key={paragraph} className="standalone-legal-p">
                    {paragraph}
                  </p>
                ))}
              </section>
            ))}
          </article>
        ) : (
          <p className="standalone-legal-p">文档不存在。</p>
        )}
      </div>
    </div>
  );
}
